import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { mergeMap, Observable } from 'rxjs';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  private oidcSecurityService = inject(OidcSecurityService);

  intercept(
    request: HttpRequest<object>,
    next: HttpHandler
  ): Observable<HttpEvent<object>> {
    return this.oidcSecurityService.getAccessToken().pipe(
      mergeMap(token => {
        const headers: Headers = {
          Authorization: `Bearer ${token}`,
        };
        if (
          request.url.includes('test-api.viatracks.com/api') ||
          request.url.includes(environment.endpoints.restApi)
        ) {
          // Gives request full priority
          headers['ClientId'] = 'devinco';
        }

        return next.handle(
          request.clone({
            setHeaders: headers,
          })
        );
      })
    );
  }
}

interface Headers {
  [name: string]: string | string[];
}
